import { Grid, useTheme } from '@mui/material';
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import AssignmentBasicDetailsSection from './AssignmentBasicDetailsSection';
import { useParams } from 'react-router-dom';
import { Formik } from 'formik';

const AssignmentDetailsForm = () => {
    const { sponsorId, assignmentId } = useParams();
      const theme = useTheme();
    const dispatch = useDispatch();
    const organization = useSelector((state) =>
      state.pfas.organizations.find((sponsor) => String(sponsor.id) === String(sponsorId))
    );
  return (
      <Grid container rowGap={2} sx={{ mt: 2 }}>
          <AssignmentBasicDetailsSection />
    </Grid>
  )
}

export default AssignmentDetailsForm
